// extracted by mini-css-extract-plugin
export default {"tableContainer":"AlertHistory_tableContainer__jt4TI","tableStyle":"AlertHistory_tableStyle__OM0mY"};